import { take, call, put } from 'redux-saga/effects';
import * as types from '../../../lib/actionTypes.es6'
import * as actions from './actions';

//import { getElasticSearchResults } from '../../../../lib/requests.es6';

import { GAloggerException } from '../../../lib/monitoring.es6';
import { unAuthorizedNotification } from '../../../lib/access.es6';
import { getElasticSearchResults } from '../../../lib/requests.es6';

export function* getElasticSearchResultsRequestWatcher() {
  for (;;) {
    const request = yield take(types.GET_ELASTIC_SEARCH_REQUEST);
    try {
      const response = yield call(getElasticSearchResults, request.payload);
      yield put(actions.getElasticSearchSuccess(response.data));
    } catch (e) {
      let errorMessage = 'An unexpected error occurred';
      if (e.response) {
        errorMessage = e.response.data;
      }
      yield put(actions.getElasticSearchFailure(errorMessage));

      GAloggerException(e);
      unAuthorizedNotification(e);
    }
  }
}












